import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { BuildingModel } from '@/api/models/building';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_GetAllEmailSignature_Building = {
  signature: string;
};

const METHOD = 'GET';
const ENDPOINT = 'building/:id/signature';
export const QUERY_KEY = (id: BuildingModel['id']) => getQueryKey(METHOD, ENDPOINT, { id });

export const useGetEmailSignature = (buildingId: BuildingModel['id'], enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(buildingId),
    queryFn: async () => {
      try {
        const data = await handleApiCall<ApiResponse_GetAllEmailSignature_Building>(
          session,
          METHOD,
          getResolvedEndpoint(ENDPOINT, {
            id: buildingId.toString(),
          })
        );

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch email signature.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
